export default __webpack_public_path__ + "static/media/8insta.6b26ed2e.jpg";